<template>
  <div class="container-fluid">
    <div class="row justify-content-between my-3">
      <div class="col">
        <h4>Ангилалууд {{catpath==null}}</h4>
      </div>
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-success"
          data-toggle="modal"
          data-target="#schoolModal"
        >Ангилал нэмэx</button>
      </div>
    </div>
    <div class="card shadow mb-4">
      <div class="card-header py-3"></div>
      <div class="card-body" v-if="items!=null && items.length>0">
        <div class="table-responsive">
          <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
            <thead>
              <tr>
                <th>№</th>
                <th>Нэр</th>
                <th>Дэлгэрэнгүй</th>

                <th>Үйлдэл</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(item, index) in items" v-bind:key="item.id">
                <td>{{index+1}}</td>
                <td>{{item.name}} ({{item.shortName}})</td>
                <td>{{item.description}}</td>
                <!-- <td>{{topic.createdAt | formatDate}}</td> -->

                <td>
                  <button class="btn btn-primary btn-sm" @click="_goDetail(item.id)">xараx</button>
                  <button class="btn btn-warning btn-sm ml-2" @click="_editSchool(item)">засах</button>
                  <!-- <button class="btn btn-danger" @click="_deletecategoryartment(category)">устгах</button> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else class="alert alert-warning">Одоогоор мэдээлэл ороогүй байна.</div>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="schoolModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="schoolModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="schoolModalLabel">Ангилал нэмэх</h5>

            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="user">
              <div class="form-group">
                <label>Нэр</label>
                <input
                  v-model.trim="object.name"
                  class="form-control"
                  aria-describedby="emailHelp"
                  placeholder="Ангилалын нэр"
                />
              </div>
              <!-- <div class="form-group">
                <label>Товчилсон нэр</label>
                <input
                  v-model.trim="object.shortName"
                  class="form-control"
                  aria-describedby="emailHelp"
                  placeholder="Товчилсон нэр"
                />
              </div>
              <div class="form-group">
                <label>Англи нэр</label>
                <input
                  v-model.trim="object.engName"
                  class="form-control"
                  aria-describedby="emailHelp"
                  placeholder="Англи нэр"
                />
              </div>
              <div class="form-group">
                <label>Тайлбар мэдээлэл</label>
                <textarea
                  rows="10"
                  v-model.trim="object.description"
                  class="form-control"
                  id="exampleInputPassword"
                  placeholder="Тайлбар мэдээлэл"
                />
              </div>-->

              <hr />
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Цуцлаx</button>
            <button
              @click="save"
              type="button"
              class="btn btn-primary btn-user btn-block"
              data-dismiss="modal"
            >Xадгалаx</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../firebaseConfig.js");

export default {
  data() {
    return {
      parent: null,
      items: [],
      object: {
        name: "",
        shortName: "",
        engName: "",
        description: ""
      }
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"])
  },

  methods: {
    _getQA() {
      if (this.catpath == null) {
        fb.db.collection("items").onSnapshot(querySnapshot => {
          this.items = [];
          querySnapshot.forEach(doc => {
            let object = doc.data();
            object.id = doc.id;
            this.items.push(object);
          });
        });
      } else {
        fb.db
          .collection("schools")
          .doc(this.schoolId)
          .onSnapshot(doc => {
            let school = doc.data();
            school.id = doc.id;
            this.school = school;
          });
      }
    },
    _goQuestions(postId) {
      this.$router.push({ name: "Questions", params: { qaId: postId } });
    },
    _goDetail(itemId) {
        console.log(itemId);
    //   this.$router.push({
    //     name: "ACategories",
    //     params: { catpath: itemId }
    //   });
    },
    save() {
      if (
        this.object != null &&
        this.object != null &&
        this.object.name != ""
      ) {
        if (this.object.id != null && this.object.id != "") {
          fb.db
            .collection("items")
            .doc(this.object.id)
            .update({
              name: this.object.name,
              //   shortName: this.object.shortName,
              //   engName: this.object.engName,
              //   description: this.object.description,
              modifiedAt: new Date(),
              modifiedUser: fb.usersCollection.doc(
                this.$store.getters.currentUser.uid
              )
            });
        } else {
          this.object.createdAt = new Date();
          this.object.userId = this.$store.getters.currentUser.uid;
          this.object.user = fb.usersCollection.doc(
            this.$store.getters.currentUser.uid
          );
          fb.db
            .collection("items")
            .doc()
            .set(this.object);
        }
        this.object = {
          name: null
          //   shortName: null,
          //   description: null
        };
      } else {
        alert("Ангилалын нэрээ оруулна уу");
      }
    },
    _editSchool(school) {
      this.object = Object.assign({}, school);
      $("#schoolModal").modal("toggle");
    },
    _deleteSchool(school) {
      var result = confirm("Та " + school.name + " устгах уу?");
      if (result) {
        fb.db
          .collection("items")
          .doc(school.id)
          .delete();
      }
    }
  },
  props: {
    catpath: {
      required: true
    }
  },
  created() {
    var _this = this;
    this._getQA();
  },

  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    }
  }
};
</script>
